import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {JhiEventManager} from 'ng-jhipster';
import {Crops} from '@entities/canh-tac/canh-tac.model';
import {CanhTacService} from '@entities/canh-tac/canh-tac.service';

@Component({
  selector: 'app-canh-tac-mgmt-delete-person-dialog',
  templateUrl: './canh-tac-delete-person-dialog.component.html',
})
export class CanhTacMgmtDeletePersonDialogComponent implements OnInit {
  lo: Crops;
  userId: any;

  @HostListener('window:keyup.esc')
  private onKeyUp() {
    this.dialogRef.close();
  }

  constructor(
    private dialogRef: MatDialogRef<CanhTacMgmtDeletePersonDialogComponent>,
    private canhTacService: CanhTacService,
    private eventManager: JhiEventManager,
  ) {}
  ngOnInit() {}
  confirmDelete() {
    const valueCurent = [];
    this.lo.tbDetailUsers.forEach((element) => {
      // tslint:disable-next-line:triple-equals
      if (element.id != this.userId) {
        valueCurent.push(element.id);
      }
    });
    const valueUpdate = {
      cropId: this.lo.id,
      detailUserIds: valueCurent,
    };
    this.canhTacService.updateCuratorUser(valueUpdate).subscribe((response) => {
      this.eventManager.broadcast({
        name: 'loDetailModification',
        content: 'Lo',
      });
      this.dialogRef.close(true);
    });
  }
}

@Component({
  selector: 'app-canh-tac-mgmt-delete-person-popup',
  template: '',
})
export class CanhTacMgmtDeletePersonPopupComponent
  implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<CanhTacMgmtDeletePersonDialogComponent>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private titleService: Title,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant(
        'entities.canh-tac.canh-tac-delete-person-dialog.Xóa người phụ trách_title',
      ),
    );
    this.activatedRoute.data.subscribe(({lo, userId}: Data) => {
      setTimeout(() => {
        this.dialogRef = this.dialog.open(
          CanhTacMgmtDeletePersonDialogComponent,
          {
            disableClose: true,
            width: '380px',
          },
        );
        this.dialogRef.componentInstance.lo = lo;
        this.dialogRef.componentInstance.userId = userId;

        this.dialogRef.afterClosed().subscribe(
          (result) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
          (reason) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
        );
      }, 0);
    });
  }

  ngOnDestroy() {
    this.titleService.setTitle(
      this.translate.instant(
        'entities.canh-tac.canh-tac-delete-person-dialog.Danh sách lô_title',
      ),
    );
    this.dialogRef = null;
  }
}
